import '@angular/localize/init';
export * from './lib/feature-tax-allowance-details.module';

export * from './lib/tax-allowance-details/feature-tax-allowance-details.component';
